function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import React, { useState } from 'react';

/**
 * Renders site logo with image and site name as screen-reader only h1 content.
 * @param String siteName Site name text string, read by screen readers
 * @param String homeHref Site root href, defaults to '/'
 * @param String logoSrc  SVG string for logo
 */
var Logo = function Logo(_ref) {
  var children = _ref.children,
      props = _objectWithoutPropertiesLoose(_ref, ["children"]); // console.log('Logo')


  return /*#__PURE__*/React.createElement("h1", null, /*#__PURE__*/React.createElement("a", {
    href: props.siteHref
  }, !!props.siteName && /*#__PURE__*/React.createElement("span", {
    className: "logo-sitename"
  }, props.siteName), !!props.logoSrc && /*#__PURE__*/React.createElement("div", {
    className: "logo",
    dangerouslySetInnerHTML: {
      __html: props.logoSrc
    },
    role: "img",
    "aria-label": props.ariaLabel
  })), children);
};

Logo.defaultProps = {
  siteHref: "/"
};
export default Logo;